import { useEffect, useState } from 'react';
import Image from '../assets/image/schema.jpeg';

const TYPE_OPTIONS = [
    { value: 'X', name: 'Replacement', bg: 'red' },
    { value: 'W', name: 'Repair/Weld', bg: '#03dd96' },
    { value: 'P', name: 'Paint', bg: '#629DE9' },
    { value: 'C', name: 'Rust/Corrosion', bg: 'orange' },
    { value: 'A', name: 'Scratch/Dent', bg: '#748291' },
    { value: 'N', name: 'Normal/None', bg: '#f3f3f3', color: '#000' },
];

const CAR_POINTS_DATA = [
    { id: "left_front_bumper", cx: 305.42, cy: 163.24, dataIndex: 1 },
    { id: "left_front_door", cx: 302.26, cy: 247.49, dataIndex: 2 },
    { id: "left_rear_door", cx: 302.26, cy: 320.16, dataIndex: 3 },
    { id: "left_rear_fender", cx: 309.63, cy: 422.32, dataIndex: 16 },

    { id: "hood", cx: 440.22, cy: 156.92, dataIndex: 9 },
    { id: "roof", cx: 441.28, cy: 319.11, dataIndex: 10 },
    { id: "trunk_lid", cx: 444.44, cy: 439.17, dataIndex: 11 },

    { id: "right_front_bumper", cx: 587.67, cy: 159.03, dataIndex: 15 },
    { id: "right_front_door", cx: 595.04, cy: 250.65, dataIndex: 14 },
    { id: "right_rear_door", cx: 592.94, cy: 330.69, dataIndex: 13 },
    { id: "right_rear_fender", cx: 579.24, cy: 418.11, dataIndex: 12 },

    { id: "upper_chassis_rail", cx: 785.67, cy: 127.43, dataIndex: 38 },

    { id: "under_left_upper", cx: 728.80, cy: 170.61, dataIndex: 17 },
    { id: "under_right_middle", cx: 804.63, cy: 200.10, dataIndex: 39 },
    { id: "under_left_middle", cx: 763.55, cy: 199.67, dataIndex: 18 },
    { id: "under_right_upper", cx: 839.38, cy: 167.45, dataIndex: 36 },

    { id: "under_middle_long", cx: 785.67, cy: 255.92, dataIndex: 6 },
    { id: "under_middle_large", cx: 785.35, cy: 299.10, dataIndex: 27 },

    { id: "under_lower_left", cx: 729.85, cy: 408.63, dataIndex: 28 },
    { id: "under_lower_middle", cx: 780.40, cy: 401.26, dataIndex: 29 },
    { id: "under_lower_right", cx: 837.27, cy: 408.63, dataIndex: 31 },
    { id: "under_lower_rail", cx: 779.35, cy: 457.08, dataIndex: 32 },
];

const initialTypesMap = CAR_POINTS_DATA.reduce((acc, point) => {
    const defaultOption = TYPE_OPTIONS.find(opt => opt.value === 'N') || TYPE_OPTIONS[0];
    acc[point.id] = {
        value: defaultOption.value,
        bg: defaultOption.bg,
        color: defaultOption.color || '#fff', // Varsayılan hərf rəngi ağdır
    };
    return acc;
}, {});


export default function Schema({ setValue, getValues }) {
    const carReport = getValues('car_damage_report');
    const [selectedTypes, setSelectedTypes] = useState(initialTypesMap);
    const [activePointId, setActivePointId] = useState(null);

    const handlePointClick = (pointId, e) => {
        if (e) e.stopPropagation();
        setActivePointId(pointId === activePointId ? null : pointId);
    };

    const handleTypeSelect = (pointId, typeOption) => {
        setSelectedTypes(prevTypes => {
            const updated = {
                ...prevTypes,
                [pointId]: {
                    value: typeOption.value,
                    bg: typeOption.bg,
                    color: typeOption.color || '#fff',
                },
            };

            const damageReport = Object.fromEntries(
                Object.entries(updated).map(([key, val]) => [key, val.value])
            );
            setValue('car_damage_report', damageReport);
            return updated;
        });

        setActivePointId(null);
    };

    useEffect(() => {
        if (carReport) {
            setSelectedTypes(prev => {
                const updated = { ...prev };
                Object.keys(updated).forEach(key => {
                    const reportValue = carReport[key]; 
                    if (reportValue) {
                        const matchedType = TYPE_OPTIONS.find(opt => opt.value === reportValue);

                        updated[key] = {
                            value: matchedType?.value || reportValue,
                            bg: matchedType?.bg || '#f3f3f3',
                            color: matchedType?.color || '#000',
                        };
                    }
                });
                return updated;
            });
        }
    }, [carReport]);





    return (
        <div className="relative" onClick={() => setActivePointId(null)}>
            <svg
                className='w-full'
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 1109 669"
            >
                <image xlinkHref={Image} width="1109" height="669"></image>

                {CAR_POINTS_DATA.map((point) => {
                    const currentType = selectedTypes[point.id];
                    const isPopupOpen = activePointId === point.id;
                    const r = 13;

                    return (
                        <g
                            key={point.id}
                            className='cursor-pointer'
                            onClick={(e) => handlePointClick(point.id, e)}
                        >
                            <circle
                                cx={point.cx}
                                cy={point.cy}
                                r={r}
                                fill={currentType.bg}
                                stroke="#000"
                                strokeWidth="1"
                            />
                            <text
                                x={point.cx}
                                y={point.cy}
                                textAnchor="middle"
                                dominantBaseline="middle"
                                fontSize="12"
                                fontWeight="bold"
                                fill={currentType.color}
                                pointerEvents="none"
                            >
                                {currentType.value}
                            </text>

                        </g>
                    );
                })}

                {CAR_POINTS_DATA.map((point) => {
                    const isPopupOpen = activePointId === point.id;
                    const r = 13;
                    if (!isPopupOpen) return null;

                    return (
                        <foreignObject
                            key={`${point.id}-popup`}
                            x={point.cx + r + 5}
                            y={point.cy - r - 5}
                            width="200"
                            height="150"
                            style={{ overflow: 'visible' }}
                        >
                            <div
                                xmlns="http://www.w3.org/1999/xhtml"
                                className="bg-white border text-left flex flex-col gap-1 border-gray-300 shadow-lg rounded-md p-1 z-[999] absolute"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {TYPE_OPTIONS.map((type) => (
                                    <button
                                        style={{ backgroundColor: type.bg, color: type.color || '#fff' }}
                                        key={type.value}
                                        type='button'
                                        className="block rounded-[4px] w-full px-2 py-1 text-sm text-white font-medium hover:opacity-80 transition-opacity"
                                        onClick={() => handleTypeSelect(point.id, type)}
                                    >
                                        {type.value} -
                                        {type.name}
                                    </button>
                                ))}
                            </div>
                        </foreignObject>
                    );
                })}

            </svg>
        </div>
    );
}